import { render, staticRenderFns } from "./GetSignCard.vue?vue&type=template&id=cdcb085e&"
import script from "./GetSignCard.vue?vue&type=script&lang=js&"
export * from "./GetSignCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports